/** An execution-owned discovery, carried only by prepared native menu cues. */
export interface AppCommandTarget {
  window_id: string;
  discovery_id: string;
  command_id: string;
}

const UUID =
  /^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

export function validAppCommand(value: unknown): value is AppCommandTarget {
  if (!value || typeof value !== "object" || Array.isArray(value)) return false;
  const target = value as Record<string, unknown>;
  return (
    Object.keys(target).sort().join(",") ===
      "command_id,discovery_id,window_id" &&
    typeof target.window_id === "string" &&
    /^\d+:(?:cg:)?\d+$/.test(target.window_id) &&
    typeof target.discovery_id === "string" &&
    UUID.test(target.discovery_id) &&
    typeof target.command_id === "string" &&
    UUID.test(target.command_id)
  );
}
